// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g1I7p","readAloudButton":"styles_readAloudButton__da+q3","rightContainer":"styles_rightContainer__NLw+7","leftContainer":"styles_leftContainer__tYFeT"};